// Module Vuex pour actionsAndWorks
const state = {
  currentActions: [],
  loading: false,
  error: null
}

const mutations = {
  SET_ACTIONS(state, actions) {
    state.currentActions = actions
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  UPDATE_ACTION(state, updatedAction) {
    const index = state.currentActions.findIndex(action => action.id === updatedAction.id)
    if (index !== -1) {
      state.currentActions.splice(index, 1, updatedAction)
    }
  },
  ADD_ACTION(state, action) {
    state.currentActions.push(action)
  },
  REMOVE_ACTION(state, actionId) {
    state.currentActions = state.currentActions.filter(action => action.id !== actionId)
  }
}

const actions = {
  async fetchActions({ commit }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    
    try {
      // Simuler un appel API
      const actions = [
        {
          id: '1',
          title: 'Réparation fuite plomberie',
          description: 'Fuite détectée dans la salle de bain lors de la visite d\'entrée',
          type: 'repair',
          status: 'in_progress',
          priority: 'high',
          createdAt: '2024-01-15T10:00:00',
          dueDate: '2024-01-25T17:00:00',
          estimatedCost: 350,
          progress: 75,
          assignedTo: { name: 'Jean Plombier' },
          tags: ['urgent', 'plomberie']
        }
      ]
      
      commit('SET_ACTIONS', actions)
    } catch (error) {
      commit('SET_ERROR', error.message)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateActionStatus({ commit }, { actionId, status }) {
    try {
      // Simuler un appel API
      const updatedAction = { id: actionId, status }
      commit('UPDATE_ACTION', updatedAction)
    } catch (error) {
      commit('SET_ERROR', error.message)
    }
  },

  async createAction({ commit }, actionData) {
    try {
      // Simuler un appel API
      const newAction = {
        id: Date.now().toString(),
        ...actionData,
        createdAt: new Date().toISOString()
      }
      commit('ADD_ACTION', newAction)
      return newAction
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    }
  },

  async deleteAction({ commit }, actionId) {
    try {
      // Simuler un appel API
      commit('REMOVE_ACTION', actionId)
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    }
  }
}

const getters = {
  currentActions: state => state.currentActions,
  loading: state => state.loading,
  error: state => state.error,
  actionsByStatus: state => status => {
    return state.currentActions.filter(action => action.status === status)
  },
  actionsByPriority: state => priority => {
    return state.currentActions.filter(action => action.priority === priority)
  }
}

export default { 
  namespaced: true, 
  state, 
  mutations, 
  actions, 
  getters 
}
